import { Schema as S } from "effect";
export const Schema = S.TemplateLiteral(S.Literal("cus_"), S.String).pipe(S.annotations({
    identifier: "@open-revenue/schema/stripe/CustomerId",
    description: "The id of the customer in Stripe",
    examples: [
        "cus_1234567890"
    ]
}));
export const make = (customerId)=>S.decodeUnknown(Schema)(customerId);
export const makeUnsafe = (customerId)=>customerId;
